<div class="row">
  <div class="col-12">
    <ng-container *ngIf="easyMode && !loading && !isInModalContext">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group d-block">
            <div class="form-check form-switch">
              <input [ngModel]="inverted" [disabled]="disabled"
                     (ngModelChange)="toggleInverted()" type="checkbox" role="switch" class="form-check-input"
                     id="Inverted">
              <label class="form-check-label"
                     for="Inverted">{{'lang.globals.blacklist' | translate}}</label>
            </div>
            <span *ngIf="!disabled"
                  class="form-text text-muted">{{'lang.globals.blacklistDescription.company' | translate}}</span>
          </div>
        </div>
      </div>
      <div *ngFor="let client of clients; let i = index; first as isFirst; last as isLast"
           class="d-flex justify-content-between align-items-center border-dashed-bottom" style="padding-bottom: 1rem;
   margin-bottom: 1rem;">
        <i>{{client?.name}}</i>
        <sb-button *ngIf="!disabled" [disabled]="false" (submitClicked)="removeClient(i)"
                   classes="btn-primary mr-0 ml-2">
          <sb-icon icon="trash"></sb-icon>
        </sb-button>
      </div>
      <div *ngIf="!disabled" class="d-flex justify-content-center">
        <sb-button (submitClicked)="addClientRow()" classes="btn-primary m-0">
          + {{'lang.culls.addClient' | translate}}</sb-button>
      </div>
    </ng-container>
    <ng-container> <!-- *ngIf="!easyMode"> -->
      <sb-filter-definition [disabled]="disabled" [preselectType]="true" [isInModalContext]="isInModalContext" *ngIf="cull"
                            [(cull)]="cull" (cullChange)="emitChange($event)">
      </sb-filter-definition>
    </ng-container>
  </div>
</div>
